import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Box, Button, FormControl, FormGroup, MenuItem, Select, Switch, TextField, IconButton, RadioGroup, FormControlLabel, Radio, Grid } from '@mui/material';
import swal from 'sweetalert';
import i18next from 'i18next';

const FormQuestionsPreview = ({element, handleFormValues, formQuestions, formValues, showQuesAns, from}) => {

  const numRef = useRef(null);
  const [radioVal, setRadioVal] = useState('')

  useEffect(() => {
    checkPreFill()
  }, [element])

  const checkPreFill = () => {
    if(element?.value && typeof element.value === 'object') {
      setRadioVal(Object.keys(element.value)[0])
    } else {
      element?.value && element.value && setRadioVal(element.value)
    }
  }

  const handleRadioChange = (e, ele) => { 
    setRadioVal(e.target.value)
    handleFormValues(e?.target?.value, ele?.commonIdentifier)
  }

  const renderQuestion = (element) => {
    return (
      <Box className='quesDiv' sx={{ textAlign: 'left' }}>
        <Box className='quesTitle' sx={{ pb: 1 }}>    
            {element?.title}
        </Box>
        <div className='quesInput'>
          {getQuestionType(element)}
        </div>
      </Box>
    )
  };

  const getQuestionType = (element) => {
    switch (element.type) {
      case "text":
        return getTextType(element);
      case "number":
        return getNumberType(element);
      case "dropdown":
        return getDropdownType(element);
      case "radio":
        return getRadioType(element);
      default:
        return getTextType(element);
    }
  };
  
  const getTextType = (element) => {
    return (
      <TextField 
        placeholder={element?.placeholder} 
        variant="outlined"
        onChange={(e) => handleFormValues(e.target.value, element?.commonIdentifier)}
        defaultValue={element.value && element.value}
        disabled={true} // Keep disabled in preview mode
        fullWidth
      />
    );
  };
  
  const getNumberType = (element) => {
    return (
      <TextField
        defaultValue={element.value && element.value}
        disabled={true} // Keep disabled in preview mode
        inputRef={numRef}
        placeholder={element?.placeholder} 
        variant="outlined"
        fullWidth
        inputProps={{
          maxLength: element?.commonIdentifier === 'phone' ? 15 : 3,
          minLength: element?.commonIdentifier === 'phone' ? 5 : 1,
          inputMode: 'numeric',
          pattern: '[0-9]*',
        }}
      />
    );
  }

  const getDropdownType = (element) => {
    return (
      <Select
        id="demo-simple-select"
        onChange={(e) => handleFormValues(e.target.value, element?.commonIdentifier)}
        className='genderSelect'
        value={formValues?.gender || element.value}
        label='Please select'
        disabled={true} // Keep disabled in preview mode
        fullWidth
      >
        {
          element?.optionMap.map((o, index) => (
            <MenuItem key={index} value={o}>
              {o}
            </MenuItem>
          ))
        }
      </Select>
    )
  }

  const getRadioType = (element) => {
    return(
      <RadioGroup
        value={radioVal}
        // Remove onChange handler to make it read-only in preview
        row={from && from === "satisfaction" && true}
      >
        {
          Object.keys(element?.optionMap).length > 0 && Object.keys(element?.optionMap).map((k) => {
            return(
              <FormControlLabel 
                key={k}
                value={element.optionMap[k]} 
                control={<Radio disabled={true} />} 
                label={element.optionMap[k]}
                sx={{
                  '& .Mui-disabled': {
                    color: 'text.primary' // Keep text readable when disabled
                  }
                }}
              />
            )
          })
        }
      </RadioGroup>
    )  
  }

  return (
    <div className='formComponent preview'>
      <FormControl className='formControl' fullWidth>
        <FormGroup>
          {renderQuestion(element)}
        </FormGroup>
      </FormControl>
    </div>
  )
}

export default FormQuestionsPreview